module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-sm-12 hidden-xs align-right footer-bottom"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "mailto:jakub@foobar.beer"
    }
  }, [_vm._v("jakub@foobar.beer")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/stonavsky/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/0xCBEE"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aefa2486"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FooterContact.vue
// module id = 1849
// module chunks = 1